import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const RevealLine = ({ text, className = "", delay = 0 }) => {
    const words = text.split(" ");
    return (
        <span className={className}>
            {words.map((w, i) => (
                <span key={i} className="inline-block overflow-hidden align-bottom">
                    <motion.span
                        className="inline-block"
                        initial={{ y: "110%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.85, delay: delay + i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {w}&nbsp;
                    </motion.span>
                </span>
            ))}
        </span>
    );
};

export const Stagger = ({ children, className = "" }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-40px" }}
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.07 } } }}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
    <motion.div
        className={className}
        variants={{
            hidden: { opacity: 0, y: 24 },
            show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
        }}
    >
        {children}
    </motion.div>
);
